import * as React from 'react'
import { Link } from 'react-router-dom'
import { FormikProps } from 'formik'
import { Button, Input } from '@mobiscroll/react-latest'

interface IRecoveryPasswordFormProps extends FormikProps<{ emailOrUsername: string }> {
  isFetching: boolean
  isFetchSuccess: boolean
}

const RecoveryPasswordForm = (props: IRecoveryPasswordFormProps) => {
  const { isFetchSuccess, isFetching, values, touched, errors, handleSubmit, handleChange } = props

  const successMessage = () => {
    return (
      <div className='flex flex-column'>
        <span className='fs-16 bold center'>An email has been sent to the supplied email address.</span>
        <span className='fs-12 mt1 center'>
          Follow the instructions in the email to reset your password.
          <Link className='auth-form-signin-link fs-12 bold ml1' to='/auth'>
            Go back
          </Link>
        </span>
      </div>
    )
  }

  return (
    <form className='auth-form-reset-password w310 mt4' onSubmit={handleSubmit}>
      {isFetchSuccess && successMessage()}
      {!isFetchSuccess && (
        <>
          <div className='flex flex-column mb2'>
            <span className='fs-16 bold'>Forgot password?</span>
            <span className='fs-12'>No problem. We’ll send password reset instructions.</span>
          </div>
          <Input
            cssClass='auth-form-input'
            error={!!(errors.emailOrUsername && touched.emailOrUsername)}
            errorMessage={errors.emailOrUsername}
            inputStyle='box'
            label='Username or email'
            labelStyle='floating'
            name='emailOrUsername'
            startIcon='user4'
            theme='ios'
            value={values.emailOrUsername}
            onChange={handleChange}
          />
          <Button className='auth-form-reset-password-btn' disabled={isFetching} variant='standard'>
            {!isFetching ? 'Submit' : 'Submitting request...'}
          </Button>
          <div className='mt1'>
            <span className='fs-12'>
              Know your password?
              <Link className='auth-form-signin-link fs-12 bold ml1' to='/auth'>
                Sign in
              </Link>
            </span>
          </div>
        </>
      )}
    </form>
  )
}

export default RecoveryPasswordForm



// WEBPACK FOOTER //
// ./src/containers/auth/RecoveryPasswordForm.tsx